import { Badge } from '@postscript/components';
import React from 'react';

import { RuntimeContextOffer } from '../types';

interface OfferChipProps {
  offer: RuntimeContextOffer;
}

export const OfferChip: React.FC<OfferChipProps> = ({ offer }) => (
  <Badge variant="neutral" size="small">
    {offer.title}
  </Badge>
);
